exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".WellList {\n  padding-top: 15px; }\n  .WellList .tooltip-component {\n    display: inline-block;\n    position: relative;\n    cursor: pointer;\n    padding: 0px 12px;\n    margin: 0 5px; }\n  .WellList .isComplete [data-prefix=\"far\"] {\n    margin: 0 8px 0 0;\n    color: green; }\n  .WellList .isNotComplete [data-prefix=\"far\"] {\n    margin: 0 8px 0 0;\n    color: red; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/Components/Main/WellList/WellList.scss
// module id = 494
// module chunks = 0